module.exports = __webpack_public_path__ + "1dffde68fa2ce6c04bbbfe6b5c3d52ea.png";